import { t } from '../../../../utils/translate';
import { TableAction } from '..';

export const ColumnOptions = (
	name: string,
	component: string,
	columnIndex: number,
	totalColumns: number,
	canDeleteColumn: boolean,
	isTemplateField: boolean,
	nonSortableColumns: string[],
	canEditColumn?: boolean,
	canMoveColumn?: boolean
) => {
	// Initialize items array
	const items: any[] = [];
	const moveLeft = canMoveColumn && columnIndex > 1;
	const moveRight = canMoveColumn && columnIndex > 0 && columnIndex < totalColumns - 1;

	// Add edit field option if allowed
	if (canEditColumn) {
		items.push({
			label: t('dynamic-components:dropdownColumnOptions.editField'),
			key: `edit_${name}`,
		});
	}

	// Add sort options if the field is sortable
	if (!nonSortableColumns.includes(component)) {
		// Add divider only if there are already items
		if (items.length > 0) {
			items.push({ type: 'divider' });
		}
		items.push(
			{
				label: t('dynamic-components:dropdownColumnOptions.sortAscending'),
				key: `asc_${name}`,
			},
			{
				label: t('dynamic-components:dropdownColumnOptions.sortDescending'),
				key: `desc_${name}`,
			}
		);
	}

	if (moveLeft || moveRight) {
		// Add divider only if there are already items
		if (items.length > 0) {
			items.push({ type: 'divider' });
		}

		if (moveLeft) {
			items.push({
				label: t('dynamic-components:dropdownColumnOptions.moveLeft'),
				key: TableAction.MOVE_LEFT + `_${name}`,
			});
		}
		if (moveRight) {
			items.push({
				label: t('dynamic-components:dropdownColumnOptions.moveRight'),
				key: TableAction.MOVE_RIGHT + `_${name}`,
			});
		}
	}

	// Add remove field option if not the first column
	if (columnIndex !== 0 && canDeleteColumn && canEditColumn && !isTemplateField) {
		// Add divider only if there are already items
		if (items.length > 0) {
			items.push({ type: 'divider' });
		}
		items.push({
			label: t('dynamic-components:dropdownColumnOptions.removeField'),
			danger: true,
			key: `remove_${name}`,
		});
	}

	return items;
};
